<script setup lang="ts">
import { computed } from 'vue'

import OutstreamAd from './OutstreamAd.vue'
import DebugAd from './DebugAd.vue'
import { useClient } from '../../../utils/client-only'
import RectangleAd from './RectangleAd.vue'
import BannerAd from './BannerAd.vue'
import { useContentBlock } from '../../../content-blocks/composables/use-content-block'

// Define props for the component
const props = defineProps<{ id: string }>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, '__injected_ad__')

const { isClient } = useClient()

const isDebug = computed(() => {
  if (isClient.value) {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('showAdSlotMarker') === 'true'
  }
  return false
})
</script>

<template>
  <!-- Debug Ad -->
  <DebugAd v-if="isDebug"
           :enabled="contentBlock.enabled"
           :type="contentBlock.data.adSlotMarker.adType" />

  <!-- Outstream Ad -->
  <OutstreamAd v-if="contentBlock.data.adSlotMarker.adType === 'outstream' && contentBlock.enabled"
               :index="contentBlock.data.adSlotMarker.injectedIndex || 0" />

  <!-- Rectangle Ad -->
  <RectangleAd v-if="contentBlock.data.adSlotMarker.adType === 'rectangle' && contentBlock.enabled"
               :id="id"
               :float="contentBlock.shouldFloat"
               :index="contentBlock.data.adSlotMarker.injectedIndex || 0" />

  <!-- Banner Ad -->
  <BannerAd v-if="contentBlock.data.adSlotMarker.adType === 'banner' && contentBlock.enabled"
            :index="contentBlock.data.adSlotMarker.injectedIndex || 0" />
</template>
